(function () {
  'use strict';

  var marketRoot = window.Shopify && Shopify.routes && Shopify.routes.root
    ? Shopify.routes.root
    : '/';

  if (!marketRoot || marketRoot === '/') return;

  var marketPrefix = marketRoot.replace(/\/$/, '');
  var storefrontPath = /^\/(?:collections|products|pages|blogs|search|cart|account|policies)(?:\/|$)/;

  function routeLink(link) {
    if (!link || !link.getAttribute) return;

    var rawHref = link.getAttribute('href');
    if (!rawHref || rawHref.charAt(0) === '#') return;
    if (/^(?:mailto:|tel:|sms:|javascript:)/i.test(rawHref)) return;

    var target;
    try {
      target = new URL(rawHref, window.location.origin);
    } catch (error) {
      return;
    }

    if (target.origin !== window.location.origin) return;
    if (target.pathname === marketPrefix || target.pathname.indexOf(marketPrefix + '/') === 0) return;
    if (target.pathname !== '/' && !storefrontPath.test(target.pathname)) return;

    var routedPath = target.pathname === '/'
      ? marketRoot
      : marketPrefix + target.pathname;

    link.setAttribute('href', routedPath + target.search + target.hash);
  }

  function routeTree(root) {
    if (!root) return;
    if (root.matches && root.matches('a[href]')) routeLink(root);
    if (!root.querySelectorAll) return;
    root.querySelectorAll('a[href]').forEach(routeLink);
  }

  routeTree(document);

  if ('MutationObserver' in window) {
    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'attributes') {
          routeLink(mutation.target);
          return;
        }

        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) routeTree(node);
        });
      });
    }).observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['href']
    });
  }
})();
